// Speisekarte – Restaurant Poseidon Viechtach
export const RESTAURANT = {
  name: "Poseidon",
  city: "Viechtach",
  phone: "09942 941629",
  phoneTel: "+4999429416 29".replace(/\s/g, ""),
  address: "Stadtpl. 5, 94234 Viechtach",
  hours: [
    { days: "Montag", lunch: "11:30 – 13:30", dinner: "17:00 – 21:00" },
    { days: "Dienstag", lunch: "11:30 – 13:30", dinner: "17:00 – 21:00" },
    { days: "Mittwoch", lunch: "Ruhetag", dinner: "Ruhetag", closed: true },
    { days: "Donnerstag", lunch: "11:30 – 13:30", dinner: "17:00 – 21:00" },
    { days: "Freitag", lunch: "11:30 – 13:30", dinner: "17:00 – 21:00" },
    { days: "Samstag", lunch: "11:30 – 13:30", dinner: "17:00 – 21:00" },
    { days: "Sonntag", lunch: "11:30 – 13:30", dinner: "17:00 – 21:00" },
  ],
};

export const MENU = [
  {
    id: "mittag",
    title: "Mittagskarte",
    note: "Werktags 11:30 – 13:30 Uhr",
    items: [
      { name: "Gyros", price: "13,00 €" },
      { name: "Gyros und Kalamaris", price: "13,80 €" },
      { name: "Gyros und Souflaki", price: "13,80 €" },
      { name: "Gyros, Schweinesteak und Bifteki", price: "15,00 €" },
      { name: "Kalamaris", price: "13,50 €" },
      { name: "Gyros mit Metaxasoße", price: "14,50 €" },
      { name: "Kalamaris und Scampi", price: "14,00 €" },
      { name: "Salat mit Gyros und Zaziki", price: "12,00 €" },
      { name: "Salat mit Kalamari und Zaziki", price: "12,00 €" },
    ],
  },
  {
    id: "kalt",
    title: "Kalte Vorspeisen",
    items: [
      { name: "Zaziki", price: "5,50 €" },
      { name: "Taramas", price: "5,50 €" },
      { name: "Käsesalat, Auberginen, Oliven, Peperoni", price: "7,50 €" },
      { name: "Feta Natur", price: "7,50 €" },
      { name: "Kalte Platte (1 Person)", price: "16,00 €" },
    ],
  },
  {
    id: "warm",
    title: "Warme Vorspeisen",
    items: [
      { name: "Saganaki paniert", desc: "Schafskäse paniert", price: "10,50 €" },
      { name: "Saganaki überbacken", desc: "Schafskäse natur mit Tomaten, Knoblauch, Peperoni und Zwiebeln", price: "11,50 €" },
      { name: "Saganaki Scampi", desc: "Scampi in Tomatensoße, Knoblauch und Schafskäse", price: "12,00 €" },
      { name: "Dolmades", desc: "Gefüllte Weinblätter mit Hackfleisch", price: "7,50 €" },
      { name: "Octopus vom Grill", price: "16,00 €" },
      { name: "Zucchini gebacken", price: "9,00 €" },
      { name: "Paprika, gefüllt mit Schafskäse", price: "9,00 €" },
      { name: "Riesenbohnen mit Schafskäse", price: "7,50 €" },
      { name: "Peperoni vom Grill", price: "6,00 €" },
      { name: "Pitta-Fladenbrot", price: "2,50 €" },
      { name: "Knoblauchbrot mit Zaziki", price: "4,80 €" },
      { name: "Pitta mit Zaziki", price: "4,00 €" },
      { name: "Warme Platte (1 Person, vegetarisch)", price: "17,00 €" },
      { name: "Halumi", desc: "Ziegenkäse", price: "9,50 €" },
    ],
  },
  {
    id: "suppen",
    title: "Suppen",
    items: [
      { name: "Hühnersuppe", price: "4,50 €" },
      { name: "Bohnensuppe", price: "4,50 €" },
    ],
  },
  {
    id: "salate",
    title: "Salate",
    items: [
      { name: "Salat mit Thunfisch", price: "15,50 €" },
      { name: "Salat mit Gyros", price: "15,50 €" },
      { name: "Salat mit Kalamari", price: "15,50 €" },
      { name: "Salat mit Hähnchenbrustfilet", price: "15,50 €" },
      { name: "Bauernsalat", price: "15,50 €" },
      { name: "Salat mit Scampi", price: "16,00 €" },
      { name: "Krautsalat", price: "4,50 €" },
      { name: "Beilagensalat", price: "4,50 €" },
      { name: "Kleiner Bauernsalat", price: "7,50 €" },
    ],
  },
  {
    id: "beilagen",
    title: "Beilagen",
    items: [
      { name: "Pommes frites", price: "4,50 €" },
      { name: "Reis mit Tomatensoße", price: "4,00 €" },
      { name: "Grüne Bohnen", price: "6,00 €" },
      { name: "Riesenbohnen", price: "6,00 €" },
      { name: "Extra Metaxasoße", price: "4,50 €" },
      { name: "Extra Pfeffersoße", price: "4,50 €" },
      { name: "Portion Ketchup und Mayonnaise", price: "0,50 €" },
    ],
  },
  {
    id: "fisch",
    title: "Fischgerichte",
    note: "Alle Fischgerichte mit Beilagen: Reis, Pommes und Salat",
    items: [
      { name: "Kalamaris", price: "19,90 €" },
      { name: "Kalamaris und Scampi", price: "21,00 €" },
      { name: "Frisches Lachsfilet vom Grill", price: "21,50 €" },
      { name: "Zanderfilet", price: "22,00 €" },
      { name: "Baby-Kalamaris vom Grill", price: "19,50 €" },
      { name: "Scampi vom Grill", price: "28,50 €" },
      { name: "Gavros – kleine Fische", price: "17,50 €" },
    ],
  },
  {
    id: "platten",
    title: "Gemischte Teller vom Grill",
    items: [
      { name: "Ouzo-Teller", desc: "Gyros, Bifteki, Steak, Lammkotelett", price: "22,00 €" },
      { name: "Lindos-Teller", desc: "Gyros mit Kalamari", price: "18,50 €" },
      { name: "Saloniki-Teller", desc: "Gyros mit Souflaki", price: "17,50 €" },
      { name: "Poseidon-Teller", desc: "Gyros, Souflaki, Kalamari", price: "21,00 €" },
      { name: "Apollo-Teller", desc: "Gyros mit Bifteki", price: "17,50 €" },
      { name: "Akropolis-Teller", desc: "Souflaki, Kalamari", price: "17,50 €" },
      { name: "Delphi-Teller", desc: "Gyros, Souflaki, Steak, Bifteki, Leber", price: "24,00 €" },
      { name: "Trikala-Teller", desc: "Gyros mit Rinderleber", price: "17,80 €" },
      { name: "Marathon-Teller", desc: "Gyros, Steak, Kalamari, Scampi", price: "23,00 €" },
      { name: "Hähnchenschnitzel mit Pommes und Salat", price: "17,00 €" },
      { name: "Bauernteller", desc: "Gyros, Souflaki, Bifteki", price: "19,50 €" },
    ],
  },
  {
    id: "fleisch",
    title: "Fleischgerichte vom Grill",
    note: "Mit Pommes frites und Salat",
    items: [
      { name: "Gyros", price: "17,00 €" },
      { name: "Gyros mit Pitta", price: "17,50 €" },
      { name: "Gyros mit Metaxasoße", price: "18,50 €" },
      { name: "Bifteki", price: "17,00 €" },
      { name: "Bifteki gefüllt", price: "18,50 €" },
      { name: "Bifteki mit Metaxasoße", price: "18,50 €" },
      { name: "Souflaki", price: "17,50 €" },
      { name: "Schweinesteak", price: "17,50 €" },
      { name: "Schweinesteak mit Metaxasoße", price: "18,50 €" },
      { name: "Rinderleber", price: "17,90 €" },
      { name: "Lammkoteletts", price: "24,00 €" },
      { name: "Hähnchenbrustfilet", price: "17,00 €" },
      { name: "Bauernspieß mit Pfeffersauce", price: "21,00 €" },
      { name: "Meteora-Spieß mit Schmelzkäse", price: "18,50 €" },
      { name: "Schweinefilet mit Pfeffersauce", price: "20,50 €" },
      { name: "Hähnchenbrustfilet mit Metaxasoße und Käse überbacken", price: "18,50 €" },
      { name: "Gyros mit Pfeffersoße", price: "18,50 €" },
    ],
  },
  {
    id: "ofen",
    title: "Aus dem Backofen",
    items: [
      { name: "Lammkeule in Tomatensoße", desc: "Mit grünen Bohnen, Riesenbohnen, Pommes frites oder Tomatenreis – dazu gemischter Salat", price: "21,50 €" },
      { name: "Mousakas", desc: "Auflauf mit Auberginen, Hackfleisch und Bechamel – mit gemischtem Salat", price: "16,00 €" },
      { name: "Mousakas vegetarisch mit Gemüse", price: "15,00 €" },
    ],
  },
  {
    id: "kinder",
    title: "Kinderteller",
    items: [
      { name: "Gyros mit Pommes", price: "11,00 €" },
      { name: "Kalamari mit Pommes", price: "11,00 €" },
      { name: "Souflaki mit Pommes", price: "11,00 €" },
      { name: "Schweineschnitzel mit Pommes", price: "11,00 €" },
    ],
  },
];
